(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoController', PedidoController);

    PedidoController.$inject = ['DataUtils', 'Pedido', 'PedidoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PedidoController(DataUtils, Pedido, PedidoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.pedidos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.b64toBlob = b64toBlob;
        vm.sucessoDownloadShape = sucessoDownloadShape;
        vm.downloadShape = downloadShape;

        vm.downloadReceituario = downloadReceituario;
        vm.sucessoDownloadReceituario = sucessoDownloadReceituario;

        loadAll();

        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
          
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        function sucessoDownloadShape(data){
            var filename = 'shapefile';
            console.log("SUCESSO");
            var ct = data[0].shapefileContentType;
            var dados = data[0].shapefile;
            
            if(ct === null) {
                alert("Nenhum shapefile associado ao mapa");
                return;
            }

            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }

        function sucessoDownloadReceituario(data){
            var filename = 'receituario';
            console.log("SUCESSO");
            var ct = data[0].receituarioContentType;
            var dados = data[0].receituario;
            
            if(ct === null) {
                alert("Nenhum receituário associado ao mapa");
                return;
            }

            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }

        function downloadShape(id){
            Pedido.queryShapefile({pedidoid: id}, vm.sucessoDownloadShape);
        }

        function downloadReceituario(id){
            Pedido.queryReceituario({pedidoid: id}, vm.sucessoDownloadReceituario);
        }

        function loadAll () {
            if (vm.currentSearch) {
                PedidoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: "id,desc"
                }, onSuccess, onError);
            } else {
                Pedido.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: "id,desc"
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.pedidos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.pedidos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.pedidos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.pedidos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
